// extracted by mini-css-extract-plugin
export default {"panelContainer":"FeatureList_panelContainer__0s3u7"};